import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getSafeNumber = params => {
  return ApiService.query(`safeNumber/get/?${stringify(params)}`);
};

export const useSafeNumber = params => {
  return ApiService.query(`safeNumber/use/?${stringify(params)}`);
};
